import dayjs from "dayjs";

// Mock Flight Operation Data
export const mockFlightOperations = [
    {
        id: 1,
        flight_number: "MU5101",
        flight_date: dayjs("2024-07-15").toISOString(),
        day_of_week: 1,
        departure_airport: "SHA",
        arrival_airport: "PEK",
        std: dayjs("2024-07-15T08:00:00Z").toISOString(),
        sta: dayjs("2024-07-15T10:15:00Z").toISOString(),
        etd: null,
        eta: null,
        atd: null,
        ata: null,
        aircraft_reg: "B-1234",
        aircraft_type: "A320",
        status: "SCHEDULED",
        remarks: "Normal flight",
        source_schedule_id: 101,
        source_flight_id: 201,
    },
    {
        id: 2,
        flight_number: "CZ3102",
        flight_date: dayjs("2024-07-15").toISOString(),
        day_of_week: 1,
        departure_airport: "CAN",
        arrival_airport: "SHA",
        std: dayjs("2024-07-15T11:30:00Z").toISOString(),
        sta: dayjs("2024-07-15T13:45:00Z").toISOString(),
        etd: dayjs("2024-07-15T11:45:00Z").toISOString(),
        eta: dayjs("2024-07-15T14:00:00Z").toISOString(),
        atd: null,
        ata: null,
        aircraft_reg: "B-5678",
        aircraft_type: "B737",
        status: "DELAYED",
        delay_code: "AT",
        delay_reason: "Air Traffic Control",
        remarks: "Delayed due to ATC",
        source_schedule_id: 102,
        source_flight_id: 202,
    },
    {
        id: 3,
        flight_number: "CA1831",
        flight_date: dayjs("2024-07-16").toISOString(),
        day_of_week: 2,
        departure_airport: "PEK",
        arrival_airport: "SHA",
        std: dayjs("2024-07-16T09:00:00Z").toISOString(),
        sta: dayjs("2024-07-16T11:10:00Z").toISOString(),
        etd: null,
        eta: null,
        atd: dayjs("2024-07-16T09:05:00Z").toISOString(),
        ata: dayjs("2024-07-16T11:05:00Z").toISOString(),
        aircraft_reg: "B-9101",
        aircraft_type: "A330",
        status: "COMPLETED",
        remarks: "",
        source_schedule_id: 103,
        source_flight_id: 203,
    },
    // 新增航班数据以测试航路申请
    {
        id: 4,
        flight_number: "CT10711",
        flight_date: dayjs("2024-08-12").toISOString(),
        day_of_week: 1,
        departure_airport: "HGH",
        arrival_airport: "NQZ",
        std: dayjs("2024-08-12T07:00:00Z").toISOString(),
        sta: dayjs("2024-08-12T11:30:00Z").toISOString(),
        etd: null,
        eta: null,
        atd: null,
        ata: null,
        aircraft_reg: "9H-FLM",
        aircraft_type: "B747",
        status: "SCHEDULED",
        remarks: "Pending route approval",
        source_schedule_id: 104,
        source_flight_id: 204,
    },
    {
        id: 5,
        flight_number: "CT10711",
        flight_date: dayjs("2024-08-12").toISOString(),
        day_of_week: 1,
        departure_airport: "NQZ",
        arrival_airport: "BUD",
        std: dayjs("2024-08-12T13:00:00Z").toISOString(),
        sta: dayjs("2024-08-12T16:30:00Z").toISOString(),
        etd: null,
        eta: null,
        atd: null,
        ata: null,
        aircraft_reg: "9H-FLM",
        aircraft_type: "B747",
        status: "SCHEDULED",
        remarks: "Additional information requested",
        source_schedule_id: 104,
        source_flight_id: 205,
    },
    {
        id: 6,
        flight_number: "CT109",
        flight_date: dayjs("2024-08-13").toISOString(),
        day_of_week: 2,
        departure_airport: "BUD",
        arrival_airport: "HGH",
        std: dayjs("2024-08-13T08:00:00Z").toISOString(),
        sta: dayjs("2024-08-13T18:45:00Z").toISOString(),
        etd: null,
        eta: null,
        atd: null,
        ata: null,
        aircraft_reg: "9H-FLM",
        aircraft_type: "B747",
        status: "SCHEDULED",
        remarks: "Route approval confirmed",
        source_schedule_id: 104, 
        source_flight_id: 206,
    },
    {
        id: 7,
        flight_number: "CT118",
        flight_date: dayjs("2024-08-17").toISOString(),
        day_of_week: 6,
        departure_airport: "HKG",
        arrival_airport: "NQZ",
        std: dayjs("2024-08-17T06:30:00Z").toISOString(),
        sta: dayjs("2024-08-17T11:00:00Z").toISOString(),
        etd: null,
        eta: null,
        atd: null,
        ata: null,
        aircraft_reg: "9H-WFF",
        aircraft_type: "B747",
        status: "SCHEDULED",
        remarks: "Route application cancelled",
        source_schedule_id: 105,
        source_flight_id: 207,
    },
    {
        id: 8,
        flight_number: "CT118",
        flight_date: dayjs("2024-08-17").toISOString(),
        day_of_week: 6,
        departure_airport: "NQZ",
        arrival_airport: "LGG",
        std: dayjs("2024-08-17T12:30:00Z").toISOString(),
        sta: dayjs("2024-08-17T16:00:00Z").toISOString(),
        etd: null,
        eta: null,
        atd: null,
        ata: null,
        aircraft_reg: "9H-WFF",
        aircraft_type: "B747",
        status: "SCHEDULED",
        remarks: "Awaiting route approval",
        source_schedule_id: 105,
        source_flight_id: 208,
    },
    {
        id: 9,
        flight_number: "CT119",
        flight_date: dayjs("2024-08-18").toISOString(),
        day_of_week: 7,
        departure_airport: "LGG",
        arrival_airport: "HKG",
        std: dayjs("2024-08-18T07:00:00Z").toISOString(),
        sta: dayjs("2024-08-18T19:15:00Z").toISOString(),
        etd: null,
        eta: null,
        atd: null,
        ata: null,
        aircraft_reg: "9H-WFF",
        aircraft_type: "B747",
        status: "SCHEDULED",
        remarks: "Route approval rejected",
        source_schedule_id: 105,
        source_flight_id: 209,
    },
];

// Mock Transaction Data for a specific flight (e.g., flight ID 1)
// In a real app, this would be fetched based on selectedFlight.id
export const mockTransactions = {
    1: [
        {
            id: 101,
            record_type: "FUEL",
            event_description: "Fuel uplift request submitted",
            status: "PENDING", // Status specific to the transaction type
            created_at: dayjs().subtract(1, "day").toISOString(),
            operator: "System",
            related_email_id: 501,
        },
        {
            id: 102,
            record_type: "PERMIT",
            event_description: "Overflight permit application sent",
            status: "PROCESSING",
            created_at: dayjs().subtract(2, "day").toISOString(),
            operator: "Alice",
            related_email_id: 502,
        },
        {
            id: 103,
            record_type: "ACTIVATION",
            event_description: "Flight activation confirmed",
            status: "COMPLETED",
            created_at: dayjs().subtract(3, "hour").toISOString(),
            operator: "Bob",
            related_email_id: null,
        },
        {
            id: 104,
            record_type: "MVT",
            event_description: "Received MVT - Estimated Departure 08:10Z",
            status: "INFO", // MVT might just be informational
            created_at: dayjs().subtract(1, "hour").toISOString(),
            operator: "System",
            related_email_id: 503,
        },
    ],
    2: [
        {
            id: 201,
            record_type: "CATERING",
            event_description: "Catering order placed",
            status: "CONFIRMED",
            created_at: dayjs().subtract(1, "day").toISOString(),
            operator: "Charlie",
            related_email_id: 601,
        },
        {
            id: 202,
            record_type: "DELAY_INFO", // Custom type for delay status
            event_description: "Flight Delayed due to ATC",
            status: "RECORDED",
            created_at: dayjs().subtract(2, "hour").toISOString(),
            operator: "System",
            related_email_id: null,
        },
    ],
    3: [
        {
            id: 301,
            record_type: "CREW",
            event_description: "Crew hotel booking confirmed",
            status: "COMPLETED",
            created_at: dayjs().subtract(1, "day").toISOString(),
            operator: "David",
            related_email_id: 701,
        },
    ],
    // 新增航路申请相关事务模拟数据
    4: [
        {
            id: 401,
            record_type: "PERMIT",
            event_description: "Route approval application submitted to UAS",
            status: "PENDING",
            created_at: dayjs("2024-08-05T09:30:00").toISOString(),
            operator: "Maria",
            related_email_id: 1001,
        },
        {
            id: 402,
            record_type: "PERMIT",
            event_description: "UAS acknowledged receipt of route application",
            status: "PENDING",
            created_at: dayjs("2024-08-05T14:45:00").toISOString(),
            operator: "UAS Routes",
            related_email_id: 1002,
        },
        {
            id: 403,
            record_type: "PERMIT",
            event_description: "UAS approved the route application, Trip Brief issued",
            status: "APPROVED",
            created_at: dayjs("2024-08-08T11:20:00").toISOString(),
            operator: "Emily Johnson (UAS)",
            related_email_id: 1005,
        },
    ],
    5: [
        {
            id: 501,
            record_type: "PERMIT",
            event_description: "Route approval application submitted to UAS",
            status: "PENDING",
            created_at: dayjs("2024-08-05T09:30:00").toISOString(),
            operator: "Maria",
            related_email_id: 1001,
        },
        {
            id: 502,
            record_type: "PERMIT",
            event_description: "UAS acknowledged receipt of route application",
            status: "PENDING",
            created_at: dayjs("2024-08-05T14:45:00").toISOString(),
            operator: "UAS Routes",
            related_email_id: 1002,
        },
        {
            id: 503,
            record_type: "PERMIT",
            event_description: "UAS requested additional information on Turkish airspace waypoints",
            status: "IN_PROCESS",
            created_at: dayjs("2024-08-06T10:15:00").toISOString(),
            operator: "UAS Routes",
            related_email_id: 1003,
        },
        {
            id: 504,
            record_type: "PERMIT",
            event_description: "Provided detailed waypoint information to UAS",
            status: "IN_PROCESS",
            created_at: dayjs("2024-08-07T09:10:00").toISOString(),
            operator: "Maria",
            related_email_id: 1004,
        },
        {
            id: 505,
            record_type: "PERMIT",
            event_description: "UAS approved the route application with adjusted waypoints, Trip Brief issued",
            status: "APPROVED",
            created_at: dayjs("2024-08-09T15:30:00").toISOString(),
            operator: "Emily Johnson (UAS)",
            related_email_id: 1006,
        },
    ],
    6: [
        {
            id: 601,
            record_type: "PERMIT",
            event_description: "Route approval application submitted to UAS",
            status: "PENDING",
            created_at: dayjs("2024-08-05T09:30:00").toISOString(),
            operator: "Maria",
            related_email_id: 1001,
        },
        {
            id: 602,
            record_type: "PERMIT",
            event_description: "UAS acknowledged receipt of route application",
            status: "PENDING",
            created_at: dayjs("2024-08-05T14:45:00").toISOString(),
            operator: "UAS Routes",
            related_email_id: 1002,
        },
        {
            id: 603,
            record_type: "PERMIT",
            event_description: "UAS approved the route application, Trip Brief issued",
            status: "APPROVED",
            created_at: dayjs("2024-08-08T11:20:00").toISOString(),
            operator: "Emily Johnson (UAS)",
            related_email_id: 1005,
        },
        {
            id: 604,
            record_type: "PERMIT",
            event_description: "Flight plan confirmed with air traffic control",
            status: "CONFIRMED",
            created_at: dayjs("2024-08-10T16:00:00").toISOString(),
            operator: "Operations Team",
            related_email_id: 1007,
        },
    ],
    7: [
        {
            id: 701,
            record_type: "PERMIT",
            event_description: "Route approval application submitted to UAS",
            status: "PENDING",
            created_at: dayjs("2024-08-07T11:15:00").toISOString(),
            operator: "John",
            related_email_id: 1101,
        },
        {
            id: 702,
            record_type: "PERMIT",
            event_description: "UAS acknowledged receipt of route application",
            status: "PENDING",
            created_at: dayjs("2024-08-07T15:30:00").toISOString(),
            operator: "UAS Routes",
            related_email_id: 1102,
        },
        {
            id: 703,
            record_type: "PERMIT",
            event_description: "Route application cancelled due to schedule change",
            status: "CANCELLED",
            created_at: dayjs("2024-08-08T09:45:00").toISOString(),
            operator: "John",
            related_email_id: 1103,
        },
        {
            id: 704,
            record_type: "PERMIT",
            event_description: "New route application submitted with updated schedule",
            status: "PENDING",
            created_at: dayjs("2024-08-08T10:00:00").toISOString(),
            operator: "John",
            related_email_id: 1104,
        },
    ],
    8: [
        {
            id: 801,
            record_type: "PERMIT",
            event_description: "Route approval application submitted to UAS",
            status: "PENDING",
            created_at: dayjs("2024-08-07T11:15:00").toISOString(),
            operator: "John",
            related_email_id: 1101,
        },
        {
            id: 802,
            record_type: "PERMIT",
            event_description: "UAS acknowledged receipt of route application",
            status: "PENDING",
            created_at: dayjs("2024-08-07T15:30:00").toISOString(),
            operator: "UAS Routes",
            related_email_id: 1102,
        },
        {
            id: 803,
            record_type: "PERMIT",
            event_description: "UAS requested additional documentation for Belgium overflight",
            status: "IN_PROCESS",
            created_at: dayjs("2024-08-09T14:20:00").toISOString(),
            operator: "UAS Routes",
            related_email_id: 1105,
        },
        {
            id: 804,
            record_type: "PERMIT",
            event_description: "Provided additional documentation for Belgium overflight",
            status: "IN_PROCESS",
            created_at: dayjs("2024-08-10T09:30:00").toISOString(),
            operator: "John",
            related_email_id: 1106,
        },
        {
            id: 805,
            record_type: "PERMIT",
            event_description: "Awaiting response from Belgian authorities",
            status: "IN_PROCESS",
            created_at: dayjs("2024-08-11T16:45:00").toISOString(),
            operator: "UAS Routes",
            related_email_id: 1107,
        },
    ],
    9: [
        {
            id: 901,
            record_type: "PERMIT",
            event_description: "Route approval application submitted to UAS",
            status: "PENDING",
            created_at: dayjs("2024-08-07T11:15:00").toISOString(),
            operator: "John",
            related_email_id: 1101,
        },
        {
            id: 902,
            record_type: "PERMIT",
            event_description: "UAS acknowledged receipt of route application",
            status: "PENDING",
            created_at: dayjs("2024-08-07T15:30:00").toISOString(),
            operator: "UAS Routes",
            related_email_id: 1102,
        },
        {
            id: 903,
            record_type: "PERMIT",
            event_description: "Route application rejected due to incomplete flight plan",
            status: "REJECTED",
            created_at: dayjs("2024-08-09T17:00:00").toISOString(),
            operator: "UAS Routes",
            related_email_id: 1108,
        },
        {
            id: 904,
            record_type: "PERMIT",
            event_description: "Meeting scheduled to discuss revised flight plan",
            status: "REJECTED",
            created_at: dayjs("2024-08-10T10:15:00").toISOString(),
            operator: "Operations Team",
            related_email_id: 1109,
        },
        {
            id: 905,
            record_type: "PERMIT",
            event_description: "New flight plan drafted for review",
            status: "REJECTED",
            created_at: dayjs("2024-08-11T14:30:00").toISOString(),
            operator: "Flight Planning Team",
            related_email_id: 1110,
        },
    ],
};
